export default __webpack_public_path__ + "static/media/twitterhumano.5df074df.svg";